export default __webpack_public_path__ + "static/media/desktop-step-1-bonus.5dee31a2.jpg";